module.exports = __webpack_public_path__ + "img/FR12448.169ff580.png";